<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">
      离职辅导<peixun type="12" style="display:inline-block;margin-left:10px;position:relative;top:3px"></peixun>
    </div>
    <div class="rpg-pd-5-10">
      <div class="rpg-dialog-item">
        <div>人选意向把握：</div>
        <el-input
          v-model="radishPurpose"
          type="textarea"
          placeholder="时刻把握人选对于客户公司的意向，把握可能的风险"
        ></el-input>
      </div>
      <div class="rpg-dialog-item">
        <div>人选目前其他offer：</div>
        <el-input v-model="otherChance" type="textarea" placeholder="人选是否有其他机会在同步进展；"></el-input>
      </div>
      <div class="rpg-dialog-item">
        <label>离职申请模板：</label> <span class="rpg-btn rpg-btn-outline" @click="showFile">离职申请</span>
      </div>
      <div class="rpg-dialog-item">
        <div>离职流程关键资料附件：</div>
        <ol>
          <li>当天或次日用公司邮箱发送“辞职申请”给直线上级、抄送部门负责人及人力资源；【请人选截图或拍照邮件】</li>
          <li>
            跟进离职手续流程，确认离职证明上的时间及到岗时间。【人选的关键承诺：领导已经同意/批复，人力预计的离职证明时间要截图留痕】
          </li>
        </ol>
      </div>
      <div class="rpg-dialog-item">
        <label>相关附件：</label>
        <span class="rpg-btn-text" @click="showUpload"> <i class="el-icon-circle-plus"></i> 上传相关附件 </span>
        <ul>
          <li v-for="(attach, k) in attachs" :key="k">{{ attach.originalname }}</li>
        </ul>
      </div>
      <div class="rpg-dialog-item rpg-text-center">
        <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
      </div>
      <el-divider></el-divider>
      <div class="rpg-dialog-item rpg-text-center">
        <i class="el-icon-notebook-1 rpg-btn-text" @click="gotoPeixun">查看相关培训</i>
      </div>
    </div>
    <UploadDialog
      ref="UploadDialog"
      type="离职资料"
      label="离职资料"
      title="上传离职相关资料附件"
      :on-success="uploadSuccess"
    />
  </div>
</template>
<script>
import { UploadDialog } from '../../../file'
import project_notify from '../constant/project_notify'

export default {
  components: { UploadDialog },
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      radishPurpose: '',
      otherChance: '',
      rid: '',
      pid: '',
      attachs: [],
    }
  },
  async mounted() {
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    this.radishPurpose = ''
    this.otherChance = ''
    // 获取之前数据
    const res = await app.service('radish').findOffer({ rid: this.rid, pid: this.pid })
    if (res.status === 'success' && res.data.length > 0 && res.data[0].离职辅导) {
      this.radishPurpose = res.data[0].离职辅导.人选意向把握 || ''
      this.otherChance = res.data[0].离职辅导.人选目前其他offer || ''
    }
    // 获取附件
    const aRes = await app.service('radish').listAttachment({ rid: this.rid })
    if (aRes.status == 'succcess') {
      this.attachs = aRes.data.filter(a => a.type == '离职资料')
    }
  },
  methods: {
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('离职辅导')
    },
    async handleConfirm() {
      const user = app.user.account
      const time = Date.now()
      const dt = {
        离职辅导: {
          人选意向把握: this.radishPurpose,
          人选目前其他offer: this.otherChance,
          时间: time,
          顾问: user,
        },
      }
      const res = await app.service('radish').updateOffer({ rid: this.rid, pid: this.pid, data: dt, type: 'edit' })
      if (res.status == 'success') {
        this.onConfirm()
        this.$message.success('操作成功')
        const content = { 人选意向把握: this.radishPurpose, 人选目前其他offer: this.otherChance }
        project_notify.sendMessage(this.rid, this.pid, '-离职辅导', '离职辅导', content)
      } else {
        this.$message.error(res.msg)
      }
    },
    gotoPeixun() {
      window.open(`${window.frontend}/#/catalogue/培训`, '_blank')
    },
    showUpload() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      const attachData = []
      response.forEach(res => {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
          rid: this.rid,
          type: '离职资料',
        }
        attachData.push(dt)
      })
      const aRes = await app.service('radish').addAttachment(attachData)
      if (aRes.status == 'success') {
        this.$message.success('上传成功')
        this.attachs = this.attachs.concat(attachData)
        this.$refs.UploadDialog.visible()
      }
    },
    async showFile() {
      const file = {
        _id: '0faa9ccda3b0673d3a8fe8ca8fc529f6',
        md5: '0faa9ccda3b0673d3a8fe8ca8fc529f6',
        createdAt: 1568631197740,
        createdTime: 1547110822000,
        filename: '辞职申请--模版市场化风格.docx',
        originalname: '辞职申请--模版（市场化风格）.docx',
        size: 13809,
        src: 'documents/upload/0faa9ccda3b0673d3a8fe8ca8fc529f6.辞职申请--模版（市场化风格）.docx',
        uploader: ['adahe'],
        contentMd5: '6174c0dccd67b9d1814c1f3c3b373d3c',
        fileurl: '/file/1492033599/6b5dcc19-f803-4433-b1d5-5c9699767486.docx',
        previewurl: '/upload/preview.0faa9ccda3b0673d3a8fe8ca8fc529f6.辞职申请--模版（市场化风格）.pdf',
        account: 'adahe',
      }
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
